import { HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Injectable, Injector, QueryList } from "@angular/core";
import { HttpInterceptor, HttpResponse } from "@angular/common/http";
import { AuthService } from "./comman/auth.service";
import { EncryptionService } from "./encryption.service";
import { tap, mapTo, map, finalize, catchError } from "rxjs/operators";
import { environment } from "environments/environment";
import { PatientService } from "./patient.service";
import { Observable } from "rxjs/internal/Observable";
import { throwError } from "rxjs";
import { Router } from "@angular/router";
import encryptedRoutes from "../utilities/encrypetdRoutes";
@Injectable({
  providedIn: "root",
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private encrypt: EncryptionService,
    private patient: PatientService,
    private router: Router
  ) {}
  private AdminURL = environment.AdminURL;
  private AuthURL = environment.AuthURL;
  private UserURL = environment.UserURL;
  private isEncrypted = environment.isEncrypted;

  intercept(req, next) {
    let url: any;
    if (req?.url) {
      url = new URL(req.url);
    }
 console.log(url)
    function encodeSpecialCharacters(input) {
      const replacements = {
        "+": "xMl3Jk",
        "/": "Por21Ld",
        "=": "Ml32",
        xMl3Jk: "+",
        Por21Ld: "/",
        Ml32: "=",
      };

      // Create a regular expression that matches the specified characters
      const regex = /[+/=]|xMl3Jk|Por21Ld|Ml32/g;

      // Use a function to replace matched characters based on the replacements object
      return input.replace(regex, (match) => replacements[match]);
    }
    const yourHeaderKeys = req.headers.get("isEncrypted");

    if (yourHeaderKeys) {
      this.isEncrypted = yourHeaderKeys;
    }
    const serviceFarm = this.injector.get(AuthService);
    if (
      (this.isEncrypted && this.isEncrypted == true) ||
      encryptedRoutes.includes(url?.pathname)
    ) {
      if (
        url.origin == this.AdminURL ||
        url.origin == this.UserURL ||
        encryptedRoutes.includes(url?.pathname)
      ) {
        if (req.body instanceof FormData) {
          console.log(req.body, "req");
          const tokenizedReq = req.clone({
            headers: req.headers
              .set("Authorization", `Bearer ${serviceFarm.getToken()}`)
              .set("Isencrypted", `${this.isEncrypted}`),
          });

          return next.handle(tokenizedReq).pipe(
            map((event) => {
              if (event instanceof HttpResponse) {
                if (event.body.data) {
                  var decrypted = this.encrypt.decryptionAES(event.body.data);

                  return event.clone({
                    body: JSON.parse(JSON.parse(decrypted)),
                  });
                }
              }
            }),
            catchError((err: any) => {
              // if( err.status == 502 || err.statusText == "Unknown Error"){
              //   this.router.navigate(['/Select/Login/ShowError']);
              // }
              var decrypted = this.encrypt.decryptionAES(err.error.data);

              const newHttpErrorResponse = new HttpErrorResponse({
                error: JSON.parse(decrypted),
                headers: err.headers,
                status: err.status,
                statusText: err.statusText,
                url: err.url,
              });
              console.log(err, "err");

              return throwError(newHttpErrorResponse);
            })
          );
        } else {
          let encriptURL;
          if (req.url.indexOf("?") > 0) {
            let substirng = encodeSpecialCharacters(
              this.encrypt
                .EncryptAES(
                  req.url.substr(req.url.indexOf("?") + 1, req.url.length)
                )
                .toString()
            );
            encriptURL =
              req.url.substr(0, req.url.indexOf("?") + 1) + "url=" + substirng;
          }
          const tokenizedReq = req.clone({
            headers: req.headers
              .set("Authorization", `Bearer ${serviceFarm.getToken()}`)
              .set("Isencrypted", `${this.isEncrypted}`),
            body: { Data: this.encrypt.EncryptAES(req.body) },
            url: encriptURL,
          });

          return next.handle(tokenizedReq).pipe(
            map((event) => {
              if (event instanceof HttpResponse) {
                if (event.body.data) {
                  var decrypted = this.encrypt.decryptionAES(event.body.data);

                  return event.clone({
                    body: JSON.parse(JSON.parse(decrypted)),
                  });
                }
              }
            }),
            catchError((err: any) => {
              var decrypted = this.encrypt.decryptionAES(err.error.data);
              console.log(decrypted);
              const newHttpErrorResponse = new HttpErrorResponse({
                error: JSON.parse(decrypted),
                headers: err.headers,
                status: err.status,
                statusText: err.statusText,
                url: err.url,
              });
              return throwError(newHttpErrorResponse);
            })
          );
        }
      } else if (url.origin == "https://deskqa2.bimagarage.com") {
        const tokenizedReq = req.clone({
          headers: req.headers
            .set("Authorization", `Bearer ${serviceFarm.getToken()}`)
            .set("Isencrypted", `${this.isEncrypted}`),
        });

        return next.handle(tokenizedReq);
      } else {
        const tokenizedReq = req.clone({
          headers: req.headers.set(
            "Authorization",
            `Bearer ${serviceFarm.getToken()}`
          ),
          // headers:req.headers.set('Authorization', `Bearer ${serviceFarm.getToken()}`).set('Isencrypted',`${this.isEncrypted}`)
        });

        return next.handle(tokenizedReq);
      }
    } else if (
      url.origin == "https://digi-uat-storage.s3.ap-south-1.amazonaws.com"
    ) {
      const tokenizedReq = req.clone({
        // setHeaders: {
        //   Authorization : `Bearer ${serviceFarm.getToken()}`,
        //   "ngrok-skip-browser-warning":"6022" // Read token
        // }
      });

      return next.handle(tokenizedReq);
    } else {
      // const tokenizedReq = req.clone({

      //   setHeaders: {
      //     Authorization : `Bearer ${serviceFarm.getToken()}`,
      //     "ngrok-skip-browser-warning":"6022" // Read token
      //   }

      // });
      const tokenizedReq = req.clone({
        headers: req.headers
          .set("Authorization", `Bearer ${serviceFarm.getToken()}`)
          .set("Isencrypted", `${this.isEncrypted}`)
          .set("ngrok-skip-browser-warning", "6022"),
      });

      return next.handle(tokenizedReq);
    }
  }
}

// complete
